<template>
  <div id="app" :class="{fillcontain: true,bg_img: (platformInfo.appId === '2DW29x025k8')&& !($route.fullPath== '/digital'),bg_imgGD: platformInfo.appId === 'GDs7Yz9HVP9Y',tj_Digital:($route.fullPath== '/digital')}">
      <router-view v-if="($route.fullPath== '/digital')"></router-view>
    <div>
      <!-- 81主站 -->
      <div v-if="platformInfo.appId === '74web89ynsg'" v-show="$route.meta.showTabbar">
        <HeaderTop2 />
        <Nav2 />
      </div>

      <!-- (山西、山东、莲湖、天津)头部模块 -->
      <div v-else v-show="$route.meta.showTabbar">
        <HeaderTop1 />
        <Nav1 />
      </div>

      <div v-if="!($route.fullPath== '/digital')" :class="{page_center_warp: true, tj_page_center_warp: tjstyle, gd_page_center_warp: gdstyle}">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" ></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
      <Footer v-if="platformInfo.appId != '75y7k29ehv'" v-show="$route.meta.showTabbar"></Footer>
      <div id="return_top" class="go_top_dv" @click="backTop()"><img class="img" :src="publicPath + 'back_top.png' + '?time=' + new Date().getTime()" /></div>
    </div>
  </div>
</template>

<script>
import HeaderTop1 from '@/components/HeaderTop1'
import HeaderTop2 from '@/components/HeaderTop2'
import Nav1 from '@/components/Nav1'
import Nav2 from '@/components/Nav2'
import Footer from '@/components/Footer'
import { mapState, mapActions } from 'vuex'
// import { getAppid } from '@/utils/public'

export default {
  name: 'App',
  components: { HeaderTop1, HeaderTop2, Nav1, Nav2, Footer },
  data() {
    return {
      scrollTop: 1,
      appId: '2DW29x025k8'  //81联聘：74web89ynsg 山西:  app71rrf9ksr   山东:  73x94y71svg   莲湖区：75y7k29ehv 天津：2DW29x025k8
    }
  },
  created() {
    let  hostname = window.location.hostname
    // let  hostname = 'sj.81lianpin.com'
    if ((hostname === 'test-sx.81lianpin.com' || hostname === 'sj.81lianpin.com'|| hostname === 'lianhu.81lianpin.com'|| hostname === 'test-lianhu.81lianpin.com')) { 
      this.$router.replace({ path: `/stopService` })
      return
    }
    //监听页面刷新，state中的platformInfo会被清空，则监听页面刷新保存到session
    window.addEventListener('unload', this.saveState);
    //监听页面滚动
    window.addEventListener("scroll", this.showBkTop, true);

    this.$store.state.host = window.location.hostname; // 不要端口号
    // this.$store.state.host = 'test-tj.81lianpin.com'

    //初始化，获取平台配置信息
    this.initPlatformInfo();
  },
  computed: {
    ...mapState(['platformInfo', 'publicPath']),
    tjstyle() {
      return this.platformInfo.appId === '2DW29x025k8'
    },
    gdstyle() {
      return this.platformInfo.appId === 'GDs7Yz9HVP9Y'
    }
  },
  methods: {
    ...mapActions(['getAppidInfo']),

    async initPlatformInfo() {
      let res = await this.getAppidInfo();   //全局保存，平台配置信息
      // console.log("平台配置platformInfo", this.platformInfo)
      this.appId = this.platformInfo.appId;
      document.getElementsByTagName('body')[0].style.setProperty('--test', res.color);  //主题色
      let color = this.appId === 'app71rrf9ksr'? '#FFF6F6' : this.appId === '74web89ynsg'? '#01683629' : '#EEF6FF'
      document.getElementsByTagName('body')[0].style.setProperty('--bgc', color);  //主题色
    },

    //页面刷新，临时保存
    saveState() {
      sessionStorage.setItem('platformInfo', JSON.stringify(this.$store.state.platformInfo));
      sessionStorage.setItem('publicPath', JSON.stringify(this.$store.state.publicPath));
    },

    //页面滚动，显示返回顶部btn
    showBkTop(e) {
      let top = e.srcElement.scrollingElement.scrollTop;
      let bkBtn = document.getElementById('return_top');
      this.scrollTop = top;
      if (top > 150) {
        bkBtn.style.display = 'block'
      } else {
        bkBtn.style.display = 'none'
      }
    },
    //回到顶部，加计时器是为了过渡顺滑
    backTop() {
      let that = this;
      let timeTop = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timeTop)
        }
      }, 16)
    },

  }
}
</script>

<style lang="scss">
@import "./assets/style/resetcss.scss";
@import "./assets/style/common.scss";
/* 解决轮播图滑动报错 */
// *{touch-action: none;}
.page_center_warp {
  background: #fff;
}
.tj_page_center_warp {
  min-height: calc(100vh - 297px);
  // background-color: #ffffff00;
  width: 1200px;
  margin: 0 auto;
}
.gd_page_center_warp{
  min-height: calc(100vh - 297px);
  // background-color: #ffffff00;
  width: 1200px;
  margin: 0 auto;
}
.page_center {
  width: 1200px;
  min-height: 600px;
  margin: 0 auto;
}
.page {
  padding-bottom: 120px;
}
.go_top_dv {
  width: 32px;
  height: 65px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  display: none;
}

// 服务不在线时图片
.unavailable{
  z-index: 3000;
  background: url('assets/img/error.jpg') no-repeat center center;
  background-size: cover;
  .el-loading-spinner{
    top: -1000px;
  }
}
// .unavailable /deep/
</style>



// WEBPACK FOOTER //
// src/App.vue